/* istanbul ignore file */
import { registerLibrary } from '@onviobr/app-information';
import { executeSideEffects } from './tr-id-stitch.js';
export { getIdStitchValues, testHealth } from './tr-id-stitch.js';
registerLibrary({
    name: '@onviobr/tr-id-stitch',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "1.0.3",
});
executeSideEffects();
